import { withTranslation } from '@application/i18n/with_translation';
import { Flex, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Shimmer } from '@component/new_shimmer.component';
import { AppointmentData, MetaData } from '@feature/cases/case_appointment_model';
import styled from 'styled-components';
import { ContactItem } from '../_contact_item.component';

// TODO: Needs other data structures
type MergedData = AppointmentData & MetaData;

interface Props {
	data: MergedData | null;
}

const elements = {
	grid: styled.div`
		display: grid;
		grid-template: repeat(1, 1fr) / repeat(1, 1fr);
		gap: ${tokens.spacing.x2_5};

		${tokens.breakpointQuery.medium} {
			grid-template: repeat(1, 1fr) / repeat(3, 1fr);
			margin-bottom: 0;
		}
	`,
};

export function InfoViewAppointmentParticipant({ data }: Props): JSX.Element | null {
	return (
		<Flex gap={tokens.size.x2_5} fluid='horizontal'>
			<Text variant='labelLargeSemiBold'>
				{withTranslation(
					data?.type == 'physical'
						? 'PW.Component.Visits.AppointmentInfo.Title.MeetingWith'
						: 'PW.Component.Visits.AppointmentInfo.Title.CallWith',
				)}
			</Text>
			{data?.participants != null ? (
				<elements.grid>
					{data.participants.map((participant) => (
						<ContactItem
							key={`${participant.name}-${participant.title}`}
							name={participant.name}
							title={participant.title}
							imageSrc={participant.profileImageUrl}
						/>
					))}
				</elements.grid>
			) : (
				<Shimmer height={40} width={40} cornerRadius={20} />
			)}
		</Flex>
	);
}
